<template>
  <div class="loading-container">
    <div class="spinner"></div>
    <div class="loading-text">加载中...</div>
  </div>
</template>

<script>
import { setToken, setRefreshToken } from "@saas/service-api/src/plugins/auth";

export default {
  name: "mini-redirect",
  data() {
    return {
      path: "",
      accessToken: "",
      refreshToken: "",
    };
  },
  created() {
    const params = new URLSearchParams(window.location.search);
    this.accessToken = params.get("accessToken");
    this.refreshToken = params.get("refreshToken");
    this.path = params.get("path");
    console.log("========1 this.path", this.path);
    if (this.accessToken) {
      console.log("========2 this.accessToken", this.accessToken, this.refreshToken)

      setToken(this.accessToken);
      setRefreshToken(this.refreshToken);
      console.log("========3 setToken");
      if (this.path) {
        console.log("========4 replace");
        console.log("========4 ",this.$router);
        this.$router.push({
          path: this.path,
        });
      }
    }
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: var(--page-bg);
}

.spinner {
  border: 2px solid var(--border-subtle);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border-left-color: var(--text-primary);
  animation: spin 1s ease infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-text {
  margin-top: 10px;
  font-size: 14px;
  color: var(--text-primary);
}
</style>
